import { render } from "./DashboardEditor.vue?vue&type=template&id=f34d56e2&scoped=true"
import script from "./DashboardEditor.vue?vue&type=script&lang=js"
export * from "./DashboardEditor.vue?vue&type=script&lang=js"

import "./DashboardEditor.vue?vue&type=style&index=0&id=f34d56e2&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34d56e2"]])

export default __exports__